import React, { useContext, useState } from 'react'
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import FormControl from 'react-bootstrap/FormControl';
import InputGroup from 'react-bootstrap/InputGroup';
import Modal from 'react-bootstrap/Modal';
import { DataContext } from '../../../js/App';
import { DVLA_LOOKUP } from '../../../config';
import { SEND_POST_REQUEST as sendPostRequest } from '../../../utils/helpers';
import { Spinner } from 'react-bootstrap';
import './dvlaLookup.scss';

const DvlaLookup = ({name, fieldLabel, parentName}) => {
    const context = useContext(DataContext);
    const [vehicleRegistration, setVehicleRegistration] = useState("");
    const [loading, setLoading] = useState(false);
    const [dvlaData, setDvlaData] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [dataConfirmed, setDataConfirmed] = useState(false);
    const [dataIncorrect, setDataIncorrect] = useState(false);
    const [showAdditional, setShowAdditional] = useState(false);
    const [dvlaError, setDvlaError] = useState(false);
    const [dvlaObject, setDvlaObject] = useState({});
    const [dvlaOutput, setDvlaOutput] = useState("");
    const {handleUpdateValue, handleDvlaValue} = context;

    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    const handleVehicleRegistration = (e) => {        
        dvlaObject.registration = e.target.value;
        setDvlaObject(dvlaObject);
        
        handleUpdateValue(name, dvlaObject);
        setVehicleRegistration(e.target.value);
    }

    const handleAdditional = (e) => {
        setDvlaObject({
            ...dvlaObject,
            "additional" : e.target.value
        })
        handleUpdateValue(name, dvlaObject);
    }

    const confirmData = () => {
        setDataConfirmed(true);
        const tmpDvlaObject = {
            ...dvlaObject,
            "confirmed" : true
        };
        setDvlaObject(tmpDvlaObject);
        handleUpdateValue(name, tmpDvlaObject);
    }

    const handleDataIncorrect = () => {
        setDataConfirmed(false);
        const tmpDvlaObject = {
            ...dvlaObject,
            "confirmed" : false
        };
        setDvlaObject(tmpDvlaObject);
        handleUpdateValue(name, tmpDvlaObject);
        setDataIncorrect(true);
    }
    const handleDataIncorrectNo = () => {
        setDvlaData({});
        setDataConfirmed(false);
        setDataIncorrect(false);
        handleClose();
    }

    const outputData = dvlaJsonData => {
        let items = [];        
        try{
            if(dvlaJsonData.data && dvlaJsonData.data.dvlaData["Vehicle Class"]){
                const vehicleClass = dvlaJsonData.data.dvlaData["Vehicle Class"];
                let vehicleDoorPlan = "";
                if(vehicleClass === "Car"){
                    vehicleDoorPlan = dvlaJsonData.data.dvlaData["Vehicle Doors Plan"];
                }
                handleDvlaValue(parentName !== "" ? parentName : "dvlaClass", vehicleDoorPlan !== "" ? vehicleDoorPlan : vehicleClass);
            }
            for (let [key, value] of Object.entries(dvlaJsonData.data.dvlaData)) {
                items.push(
                    <p key={key} style={{ textTransform: `capitalize` }}>
                        {key} : {value}
                    </p>
                );
            }
            setDvlaObject({
                ...dvlaObject,
                "dvlaId" : dvlaJsonData.data.dvlaId
            });
            handleUpdateValue(name, dvlaObject);
        } catch{
            return <p>No results found</p>;
        }
        return items;
    };

    const lookupRegistration = anotherLookup => {
        if(anotherLookup){
            setDataConfirmed(false);
        }
        if(!dataConfirmed || anotherLookup){
            if (!loading){
                setLoading(true);
                handleShow();
            }

            sendPostRequest(
                { regNumber: vehicleRegistration },
                DVLA_LOOKUP
            ).then(response => {
                response.json().then(jsonResponse => {
                    setDvlaData(jsonResponse);
                    if (jsonResponse.status === 'error') {
                        setDvlaError(true);
                        setDvlaOutput(jsonResponse.message);
                    } else {
                        setDvlaError(false);
                        setDvlaOutput(outputData(jsonResponse));
                    }
                    setLoading(false);
                });
            });
        } else {
            handleShow();
        }
    };

    return (
    <>
        <Modal show={showModal} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>DVLA Lookup</Modal.Title>
            </Modal.Header>
            
            <Modal.Body>
                {loading === true ? (<Spinner animation="border" variant="primary" />) : (<div>{dvlaOutput}</div>)}
                {loading === false && dataIncorrect === true && (<>
                    <hr/>
                    <p>Have you entered your Registration correctly: {vehicleRegistration}</p>
                    <Button variant="outlined-primary" onClick={ () => {handleDataIncorrectNo();}}>No</Button>
                    <Button variant="primary" onClick={ () => {confirmData(); setShowAdditional(true); setDataIncorrect(false)}}>Yes</Button>
                </>)}
                {loading === false && showAdditional && (<>
                    <hr/>
                    <Col column sm="12"><p>Please enter any extra information that you think is relevant.</p></Col>
                    <Form.Control
                    as="textarea"
                    name={name}
                    aria-describedby="dvlaLookup"
                    onChange={e => handleAdditional(e)}
                    />
                </>)}
            </Modal.Body>
            
            <Modal.Footer>
            {dataIncorrect === false && (<>
                    {((!dvlaError && dataConfirmed) || dvlaError) && (<>
                        <Button variant="outline-primary" onClick={handleClose}>{dataConfirmed ? (showAdditional ? "Confirm" : "Data Confirmed") : "Close"}</Button>
                        {!dvlaError && dataConfirmed && (
                            <Button variant="warning" id="dvlaLookup" onClick={ () => lookupRegistration(true)}>Lookup again</Button>
                        )}
                    </>)}
                    {!dvlaError && !dataConfirmed && (<>
                        <Button variant="outline-primary" onClick={ () => {handleDataIncorrect();}}>Data is incorrect</Button>
                        <Button variant="primary" onClick={ () => {confirmData(); handleClose();}}>Confirm Data</Button>
                        </>
                    )}
                    </>
                )}
            </Modal.Footer>
        </Modal>
        <Form.Group as={Row} className="mb-3" controlId="dvlaLookup">
            <Form.Label column sm="5">
                {fieldLabel}
            </Form.Label>
            <Col sm="7" className="inlineOptions">
            <InputGroup className="mb-3">
                <FormControl
                name={name}
                placeholder="AB12 XYZ"
                aria-label="AB12 XYZ"
                aria-describedby="dvlaLookup"
                onChange={e => handleVehicleRegistration(e)}
                />
                <Button variant="outline-primary" id="dvlaLookup" onClick={ () => lookupRegistration(false)}>
                    {dataConfirmed && "Confirmed"}
                    {!dataConfirmed && "Lookup"}
                </Button>
            </InputGroup>
            </Col>
        </Form.Group>     
    </>
    )
}
export default DvlaLookup;
